import { Paragraph, TextRun } from "docx";
import { getI18n } from "react-i18next";
import generateLvTableRow from "./generateLvTableRow";
import ConvertToString from "../Converter";

export default function generatePileheadsRow(lvData, positionNumber) {
  const t = getI18n().t;

  const textRuns = [
    new TextRun({
      text: "Pfahlköpfe",
      bold: true,
    }),
  ];

  if (lvData.pileheadSource === t("lvText.positionPileheads.pileheadSourceDetailDrawings")) {
    textRuns.push(
      new TextRun({
        text: "Kopfkonstruktion gemäß Ausführungszeichnung.",
        break: 1,
      })
    );
  }

  if (lvData.pileheadSource === t("lvText.positionPileheads.pileheadSourceSmarttitan")) {
    textRuns.push(
      new TextRun({
        text:
          "Kopfkonstruktion gemäß Zulassung bestehend aus Kopfplatte " +
          lvData.lengthWasherPlate +
          "x" +
          lvData.lengthWasherPlate +
          "x" +
          lvData.thicknesWasherPlate +
          " mm, eingespannt zwischen 2 Kugelbundmutter, sowie Übergangsrohr aus " +
          lvData.transitionTubeMaterialHumanReadable +
          " (Abmessungen gemäß Zulassung) L > " +
          lvData.totalLengthTransitionPipe +
          " mm.",
        break: 1,
      })
    );
  }

  const descriptionParagraph = new Paragraph({
    children: textRuns,
  });

  return generateLvTableRow(
    positionNumber,
    descriptionParagraph,
    ConvertToString(lvData.numberOfPileheads),
    "Stk"
  );
}
